import { Actions, resetModuleReducerState } from "@client/actions";
import { type AppState } from "@client/types";
import { type ReduxAction } from "@client/types/ReduxAction";
import { type Dispatch, type MiddlewareAPI } from "redux";

export default (api: MiddlewareAPI<Dispatch<any>, AppState>) => (next) => (action: ReduxAction<any>) => {
  next(action);

  // IMPORTANT! Breaking if before next(action)
  switch (action.type) {
    case Actions.LoadPageSuccess: {
      // TODO: better to remove reducers?
      api.dispatch(resetModuleReducerState());

      break;
    }
  }
};
